
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}

const _spaOnlyPageStub = { render: () => null };
import { default as indexkpZGh2qnTXnCxInXyiKp5FK0DXDPWXqYC_EYUhWTrRQMeta } from "/app/apps/cue-subclient/app/pages/booking/[id]/index.vue?macro=true";
import { default as _91id_93EkiMJ72j5QdEWkNINl7lRmI2ywM7NdB_AKsSpBACKn8Meta } from "/app/apps/cue-subclient/app/pages/services/[id].vue?macro=true";
import { default as index9kN1ciLv9W12YfdANxqlC3lcGK3cuYUAHf_952aVkdUMeta } from "/app/apps/cue-subclient/app/pages/services/index.vue?macro=true";
import { default as component_45stubUBgcCf3Z_YshUKm2NgUZyc9CPCdPqvbqSlWCzF1DSyo } from "/app/node_modules/.pnpm/nuxt@4.6.4_0e13fd5257b8dba9d4e17f718301a864/node_modules/nuxt/dist/pages/runtime/component-stub.js";
import { default as component_45stubUBgcCf3Z_YshUKm2NgUZyc9CPCdPqvbqSlWCzF1DSyoMeta } from "/app/node_modules/.pnpm/nuxt@4.6.4_0e13fd5257b8dba9d4e17f718301a864/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
export default [
  {
    name: "booking-checkout",
    path: "/booking/checkout",
    component: import.meta.client ? () => import("/app/apps/cue-subclient/app/pages/booking/checkout.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "booking-inventory",
    path: "/booking/inventory",
    component: import.meta.client ? () => import("/app/apps/cue-subclient/app/pages/booking/inventory.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "booking-id-details",
    path: "/booking/:id()/details",
    component: import.meta.client ? () => import("/app/apps/cue-subclient/app/pages/booking/[id]/details.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "booking-id-order",
    path: "/booking/:id()/order",
    component: import.meta.client ? () => import("/app/apps/cue-subclient/app/pages/booking/[id]/order.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "booking-id-target",
    path: "/booking/:id()/target",
    component: import.meta.client ? () => import("/app/apps/cue-subclient/app/pages/booking/[id]/target.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "orders-id-bad",
    path: "/orders/:id()/bad",
    component: import.meta.client ? () => import("/app/apps/cue-subclient/app/pages/orders/[id]/bad.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "orders-id-payment",
    path: "/orders/:id()/payment",
    component: import.meta.client ? () => import("/app/apps/cue-subclient/app/pages/orders/[id]/payment.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "orders-id-success",
    path: "/orders/:id()/success",
    component: import.meta.client ? () => import("/app/apps/cue-subclient/app/pages/orders/[id]/success.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "booking-id-oid",
    path: "/booking/:id()/:oid()",
    component: import.meta.client ? () => import("/app/apps/cue-subclient/app/pages/booking/[id]/[oid].vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "booking-id",
    path: "/booking/:id()",
    meta: indexkpZGh2qnTXnCxInXyiKp5FK0DXDPWXqYC_EYUhWTrRQMeta || {},
    component: import.meta.client ? () => import("/app/apps/cue-subclient/app/pages/booking/[id]/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    component: import.meta.client ? () => import("/app/apps/cue-subclient/app/pages/orders/[id]/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "services-id",
    path: "/services/:id()",
    meta: _91id_93EkiMJ72j5QdEWkNINl7lRmI2ywM7NdB_AKsSpBACKn8Meta || {},
    component: () => import("/app/apps/cue-subclient/app/pages/services/[id].vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/app/apps/cue-subclient/app/pages/404.vue")
  },
  {
    name: "booking",
    path: "/booking",
    component: import.meta.client ? () => import("/app/apps/cue-subclient/app/pages/booking/index.vue") : () => Promise.resolve(_spaOnlyPageStub)
  },
  {
    name: "services",
    path: "/services",
    meta: index9kN1ciLv9W12YfdANxqlC3lcGK3cuYUAHf_952aVkdUMeta || {},
    component: () => import("/app/apps/cue-subclient/app/pages/services/index.vue")
  },
  {
    name: "staff",
    path: "/staff",
    component: () => import("/app/apps/cue-subclient/app/pages/staff.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/cue-subclient/app/pages/index.vue")
  },
  {
    name: component_45stubUBgcCf3Z_YshUKm2NgUZyc9CPCdPqvbqSlWCzF1DSyoMeta?.name,
    path: "/nav",
    component: component_45stubUBgcCf3Z_YshUKm2NgUZyc9CPCdPqvbqSlWCzF1DSyo
  },
  {
    name: component_45stubUBgcCf3Z_YshUKm2NgUZyc9CPCdPqvbqSlWCzF1DSyoMeta?.name,
    path: "/services/info/:pathMatch(.*)",
    component: component_45stubUBgcCf3Z_YshUKm2NgUZyc9CPCdPqvbqSlWCzF1DSyo
  }
]